import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

export default function ReportsPageRadioButton({ cashierActivity, setCashierActivity }) {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = (event.target as HTMLInputElement).value
    setCashierActivity(newValue);
  };

  return (
    <FormControl>
      <RadioGroup
        row
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={cashierActivity}
        onChange={handleChange}
      >
        <FormControlLabel value="cashierSuspicious" control={<Radio />} label="Cashier Suspicious" />
        <FormControlLabel value="cashierFraud" control={<Radio />} label="Cashier Fraud" />
      </RadioGroup>
    </FormControl>
  );
}